var city = {
  citycode: [],
  adcode: "510000",
  name: "四川省",
  center: {
    lng: 104.076452,
    lat: 30.651696
  },
  districtList: [
    {
      citycode: "0839",
      adcode: "510800",
      name: "广元市",
      center: {
        lng: 105.844004,
        lat: 32.435774
      },
      districtList: [
        {
          citycode: "0839",
          adcode: "510812",
          name: "朝天区",
          center: {
            lng: 105.882848,
            lat: 32.651352
          }
        },
        {
          citycode: "0839",
          adcode: "510824",
          name: "苍溪县",
          center: {
            lng: 105.934756,
            lat: 31.731709
          }
        },
        {
          citycode: "0839",
          adcode: "510811",
          name: "昭化区",
          center: {
            lng: 105.957612,
            lat: 32.333173
          }
        },
        {
          citycode: "0839",
          adcode: "510823",
          name: "剑阁县",
          center: {
            lng: 105.524699,
            lat: 32.288681
          }
        },
        {
          citycode: "0839",
          adcode: "510822",
          name: "青川县",
          center: {
            lng: 105.238498,
            lat: 32.575821
          }
        },
        {
          citycode: "0839",
          adcode: "510821",
          name: "旺苍县",
          center: {
            lng: 106.290124,
            lat: 32.229074
          }
        },
        {
          citycode: "0839",
          adcode: "510802",
          name: "利州区",
          center: {
            lng: 105.845307,
            lat: 32.433756
          }
        }
      ]
    },
    {
      citycode: "0817",
      adcode: "511300",
      name: "南充市",
      center: {
        lng: 106.110565,
        lat: 30.837235
      },
      districtList: [
        {
          citycode: "0817",
          adcode: "511321",
          name: "南部县",
          center: {
            lng: 106.036349,
            lat: 31.348255
          }
        },
        {
          citycode: "0817",
          adcode: "511322",
          name: "营山县",
          center: {
            lng: 106.565524,
            lat: 31.077057
          }
        },
        {
          citycode: "0817",
          adcode: "511304",
          name: "嘉陵区",
          center: {
            lng: 106.07208,
            lat: 30.758831
          }
        },
        {
          citycode: "0817",
          adcode: "511325",
          name: "西充县",
          center: {
            lng: 105.900894,
            lat: 30.995546
          }
        },
        {
          citycode: "0817",
          adcode: "511324",
          name: "仪陇县",
          center: {
            lng: 106.303082,
            lat: 31.271693
          }
        },
        {
          citycode: "0817",
          adcode: "511302",
          name: "顺庆区",
          center: {
            lng: 106.092327,
            lat: 30.797366
          }
        },
        {
          citycode: "0817",
          adcode: "511381",
          name: "阆中市",
          center: {
            lng: 106.005046,
            lat: 31.558356
          }
        },
        {
          citycode: "0817",
          adcode: "511323",
          name: "蓬安县",
          center: {
            lng: 106.412156,
            lat: 31.028537
          }
        },
        {
          citycode: "0817",
          adcode: "511303",
          name: "高坪区",
          center: {
            lng: 106.118931,
            lat: 30.781284
          }
        }
      ]
    },
    {
      citycode: "0827",
      adcode: "511900",
      name: "巴中市",
      center: {
        lng: 106.747548,
        lat: 31.867853
      },
      districtList: [
        {
          citycode: "0827",
          adcode: "511921",
          name: "通江县",
          center: {
            lng: 107.245033,
            lat: 31.911705
          }
        },
        {
          citycode: "0827",
          adcode: "511902",
          name: "巴州区",
          center: {
            lng: 106.76887,
            lat: 31.851458
          }
        },
        {
          citycode: "0827",
          adcode: "511922",
          name: "南江县",
          center: {
            lng: 106.828697,
            lat: 32.346589
          }
        },
        {
          citycode: "0827",
          adcode: "511923",
          name: "平昌县",
          center: {
            lng: 107.103613,
            lat: 31.560436
          }
        },
        {
          citycode: "0827",
          adcode: "511903",
          name: "恩阳区",
          center: {
            lng: 106.634651,
            lat: 31.796476
          }
        }
      ]
    },
    {
      citycode: "0838",
      adcode: "510600",
      name: "德阳市",
      center: {
        lng: 104.397795,
        lat: 31.127449
      },
      districtList: [
        {
          citycode: "0838",
          adcode: "510623",
          name: "中江县",
          center: {
            lng: 104.678601,
            lat: 31.03327
          }
        },
        {
          citycode: "0838",
          adcode: "510682",
          name: "什邡市",
          center: {
            lng: 104.167345,
            lat: 31.12655
          }
        },
        {
          citycode: "0838",
          adcode: "510604",
          name: "罗江区",
          center: {
            lng: 104.510457,
            lat: 31.317388
          }
        },
        {
          citycode: "0838",
          adcode: "510683",
          name: "绵竹市",
          center: {
            lng: 104.220679,
            lat: 31.339251
          }
        },
        {
          citycode: "0838",
          adcode: "510681",
          name: "广汉市",
          center: {
            lng: 104.282204,
            lat: 30.977264
          }
        },
        {
          citycode: "0838",
          adcode: "510603",
          name: "旌阳区",
          center: {
            lng: 104.417061,
            lat: 31.143335
          }
        }
      ]
    },
    {
      citycode: "0816",
      adcode: "510700",
      name: "绵阳市",
      center: {
        lng: 104.679127,
        lat: 31.467673
      },
      districtList: [
        {
          citycode: "0816",
          adcode: "510781",
          name: "江油市",
          center: {
            lng: 104.74564,
            lat: 31.778572
          }
        },
        {
          citycode: "0816",
          adcode: "510725",
          name: "梓潼县",
          center: {
            lng: 105.170746,
            lat: 31.642635
          }
        },
        {
          citycode: "0816",
          adcode: "510704",
          name: "游仙区",
          center: {
            lng: 104.766136,
            lat: 31.473788
          }
        },
        {
          citycode: "0816",
          adcode: "510722",
          name: "三台县",
          center: {
            lng: 105.093722,
            lat: 31.095826
          }
        },
        {
          citycode: "0816",
          adcode: "510703",
          name: "涪城区",
          center: {
            lng: 104.756917,
            lat: 31.455192
          }
        },
        {
          citycode: "0816",
          adcode: "510727",
          name: "平武县",
          center: {
            lng: 104.555481,
            lat: 32.409684
          }
        },
        {
          citycode: "0816",
          adcode: "510726",
          name: "北川羌族自治县",
          center: {
            lng: 104.468163,
            lat: 31.617192
          }
        },
        {
          citycode: "0816",
          adcode: "510723",
          name: "盐亭县",
          center: {
            lng: 105.389453,
            lat: 31.208362
          }
        },
        {
          citycode: "0816",
          adcode: "510705",
          name: "安州区",
          center: {
            lng: 104.567543,
            lat: 31.534319
          }
        }
      ]
    },
    {
      citycode: "028",
      adcode: "510100",
      name: "成都市",
      center: {
        lng: 104.066301,
        lat: 30.572961
      },
      districtList: [
        {
          citycode: "028",
          adcode: "510182",
          name: "彭州市",
          center: {
            lng: 103.957706,
            lat: 30.990463
          }
        },
        {
          citycode: "028",
          adcode: "510185",
          name: "简阳市",
          center: {
            lng: 104.547644,
            lat: 30.410937
          }
        },
        {
          citycode: "028",
          adcode: "510131",
          name: "蒲江县",
          center: {
            lng: 103.506478,
            lat: 30.197558
          }
        },
        {
          citycode: "028",
          adcode: "510116",
          name: "双流区",
          center: {
            lng: 103.92342,
            lat: 30.574884
          }
        },
        {
          citycode: "028",
          adcode: "510181",
          name: "都江堰市",
          center: {
            lng: 103.647193,
            lat: 30.988763
          }
        },
        {
          citycode: "028",
          adcode: "510117",
          name: "郫都区",
          center: {
            lng: 103.900486,
            lat: 30.795113
          }
        },
        {
          citycode: "028",
          adcode: "510115",
          name: "温江区",
          center: {
            lng: 103.856423,
            lat: 30.681956
          }
        },
        {
          citycode: "028",
          adcode: "510105",
          name: "青羊区",
          center: {
            lng: 104.062415,
            lat: 30.674583
          }
        },
        {
          citycode: "028",
          adcode: "510108",
          name: "成华区",
          center: {
            lng: 104.101452,
            lat: 30.659966
          }
        },
        {
          citycode: "028",
          adcode: "510107",
          name: "武侯区",
          center: {
            lng: 104.043246,
            lat: 30.641849
          }
        },
        {
          citycode: "028",
          adcode: "510113",
          name: "青白江区",
          center: {
            lng: 104.251342,
            lat: 30.8786
          }
        },
        {
          citycode: "028",
          adcode: "510184",
          name: "崇州市",
          center: {
            lng: 103.673025,
            lat: 30.630183
          }
        },
        {
          citycode: "028",
          adcode: "510104",
          name: "锦江区",
          center: {
            lng: 104.117262,
            lat: 30.598726
          }
        },
        {
          citycode: "028",
          adcode: "510112",
          name: "龙泉驿区",
          center: {
            lng: 104.27536,
            lat: 30.556808
          }
        },
        {
          citycode: "028",
          adcode: "510118",
          name: "新津区",
          center: {
            lng: 103.810906,
            lat: 30.410404
          }
        },
        {
          citycode: "028",
          adcode: "510183",
          name: "邛崃市",
          center: {
            lng: 103.464176,
            lat: 30.41029
          }
        },
        {
          citycode: "028",
          adcode: "510129",
          name: "大邑县",
          center: {
            lng: 103.51226,
            lat: 30.573004
          }
        },
        {
          citycode: "028",
          adcode: "510121",
          name: "金堂县",
          center: {
            lng: 104.411871,
            lat: 30.86203
          }
        },
        {
          citycode: "028",
          adcode: "510106",
          name: "金牛区",
          center: {
            lng: 104.052236,
            lat: 30.691359
          }
        },
        {
          citycode: "028",
          adcode: "510114",
          name: "新都区",
          center: {
            lng: 104.158593,
            lat: 30.823568
          }
        }
      ]
    },
    {
      citycode: "0826",
      adcode: "511600",
      name: "广安市",
      center: {
        lng: 106.632647,
        lat: 30.456354
      },
      districtList: [
        {
          citycode: "0826",
          adcode: "511623",
          name: "邻水县",
          center: {
            lng: 106.930242,
            lat: 30.334911
          }
        },
        {
          citycode: "0826",
          adcode: "511602",
          name: "广安区",
          center: {
            lng: 106.641628,
            lat: 30.473943
          }
        },
        {
          citycode: "0826",
          adcode: "511621",
          name: "岳池县",
          center: {
            lng: 106.440056,
            lat: 30.538656
          }
        },
        {
          citycode: "0826",
          adcode: "511622",
          name: "武胜县",
          center: {
            lng: 106.295945,
            lat: 30.349493
          }
        },
        {
          citycode: "0826",
          adcode: "511681",
          name: "华蓥市",
          center: {
            lng: 106.783151,
            lat: 30.390439
          }
        },
        {
          citycode: "0826",
          adcode: "511603",
          name: "前锋区",
          center: {
            lng: 106.886039,
            lat: 30.496059
          }
        }
      ]
    },
    {
      citycode: "0818",
      adcode: "511700",
      name: "达州市",
      center: {
        lng: 107.46778,
        lat: 31.209278
      },
      districtList: [
        {
          citycode: "0818",
          adcode: "511724",
          name: "大竹县",
          center: {
            lng: 107.204702,
            lat: 30.736222
          }
        },
        {
          citycode: "0818",
          adcode: "511725",
          name: "渠县",
          center: {
            lng: 106.973114,
            lat: 30.836504
          }
        },
        {
          citycode: "0818",
          adcode: "511702",
          name: "通川区",
          center: {
            lng: 107.505053,
            lat: 31.214665
          }
        },
        {
          citycode: "0818",
          adcode: "511703",
          name: "达川区",
          center: {
            lng: 107.511736,
            lat: 31.196573
          }
        },
        {
          citycode: "0818",
          adcode: "511722",
          name: "宣汉县",
          center: {
            lng: 107.727198,
            lat: 31.353845
          }
        },
        {
          citycode: "0818",
          adcode: "511781",
          name: "万源市",
          center: {
            lng: 108.034393,
            lat: 32.081698
          }
        },
        {
          citycode: "0818",
          adcode: "511723",
          name: "开江县",
          center: {
            lng: 107.868609,
            lat: 31.082945
          }
        }
      ]
    },
    {
      citycode: "0825",
      adcode: "510900",
      name: "遂宁市",
      center: {
        lng: 105.592602,
        lat: 30.53268
      },
      districtList: [
        {
          citycode: "0825",
          adcode: "510981",
          name: "射洪市",
          center: {
            lng: 105.388366,
            lat: 30.871079
          }
        },
        {
          citycode: "0825",
          adcode: "510923",
          name: "大英县",
          center: {
            lng: 105.236852,
            lat: 30.594472
          }
        },
        {
          citycode: "0825",
          adcode: "510921",
          name: "蓬溪县",
          center: {
            lng: 105.707498,
            lat: 30.75763
          }
        },
        {
          citycode: "0825",
          adcode: "510904",
          name: "安居区",
          center: {
            lng: 105.45636,
            lat: 30.355091
          }
        },
        {
          citycode: "0825",
          adcode: "510903",
          name: "船山区",
          center: {
            lng: 105.568359,
            lat: 30.526201
          }
        }
      ]
    },
    {
      citycode: "0832",
      adcode: "512000",
      name: "资阳市",
      center: {
        lng: 104.627265,
        lat: 30.129236
      },
      districtList: [
        {
          citycode: "0832",
          adcode: "512022",
          name: "乐至县",
          center: {
            lng: 105.019823,
            lat: 30.275418
          }
        },
        {
          citycode: "0832",
          adcode: "512002",
          name: "雁江区",
          center: {
            lng: 104.676814,
            lat: 30.107778
          }
        },
        {
          citycode: "0832",
          adcode: "512021",
          name: "安岳县",
          center: {
            lng: 105.35551,
            lat: 30.103623
          }
        }
      ]
    },
    {
      citycode: "1833",
      adcode: "511400",
      name: "眉山市",
      center: {
        lng: 103.848417,
        lat: 30.077113
      },
      districtList: [
        {
          citycode: "1833",
          adcode: "511421",
          name: "仁寿县",
          center: {
            lng: 104.133931,
            lat: 29.995638
          }
        },
        {
          citycode: "1833",
          adcode: "511424",
          name: "丹棱县",
          center: {
            lng: 103.512859,
            lat: 30.014398
          }
        },
        {
          citycode: "1833",
          adcode: "511423",
          name: "洪雅县",
          center: {
            lng: 103.365035,
            lat: 29.915828
          }
        },
        {
          citycode: "1833",
          adcode: "511403",
          name: "彭山区",
          center: {
            lng: 103.872852,
            lat: 30.193278
          }
        },
        {
          citycode: "1833",
          adcode: "511425",
          name: "青神县",
          center: {
            lng: 103.846596,
            lat: 29.831302
          }
        },
        {
          citycode: "1833",
          adcode: "511402",
          name: "东坡区",
          center: {
            lng: 103.831868,
            lat: 30.041956
          }
        }
      ]
    },
    {
      citycode: "1832",
      adcode: "511000",
      name: "内江市",
      center: {
        lng: 105.057992,
        lat: 29.58021
      },
      districtList: [
        {
          citycode: "1832",
          adcode: "511025",
          name: "资中县",
          center: {
            lng: 104.851874,
            lat: 29.763419
          }
        },
        {
          citycode: "1832",
          adcode: "511024",
          name: "威远县",
          center: {
            lng: 104.669032,
            lat: 29.527456
          }
        },
        {
          citycode: "1832",
          adcode: "511011",
          name: "东兴区",
          center: {
            lng: 105.076107,
            lat: 29.593528
          }
        },
        {
          citycode: "1832",
          adcode: "511083",
          name: "隆昌市",
          center: {
            lng: 105.287507,
            lat: 29.339408
          }
        },
        {
          citycode: "1832",
          adcode: "511002",
          name: "市中区",
          center: {
            lng: 105.06759,
            lat: 29.587091
          }
        }
      ]
    },
    {
      citycode: "0833",
      adcode: "511100",
      name: "乐山市",
      center: {
        lng: 103.766085,
        lat: 29.552275
      },
      districtList: [
        {
          citycode: "0833",
          adcode: "511126",
          name: "夹江县",
          center: {
            lng: 103.571313,
            lat: 29.738143
          }
        },
        {
          citycode: "0833",
          adcode: "511111",
          name: "沙湾区",
          center: {
            lng: 103.550118,
            lat: 29.412404
          }
        },
        {
          citycode: "0833",
          adcode: "511112",
          name: "五通桥区",
          center: {
            lng: 103.818024,
            lat: 29.406837
          }
        },
        {
          citycode: "0833",
          adcode: "511124",
          name: "井研县",
          center: {
            lng: 104.06968,
            lat: 29.65165
          }
        },
        {
          citycode: "0833",
          adcode: "511113",
          name: "金口河区",
          center: {
            lng: 103.078597,
            lat: 29.244345
          }
        },
        {
          citycode: "0833",
          adcode: "511123",
          name: "犍为县",
          center: {
            lng: 103.949231,
            lat: 29.208118
          }
        },
        {
          citycode: "0833",
          adcode: "511132",
          name: "峨边彝族自治县",
          center: {
            lng: 103.262048,
            lat: 29.230426
          }
        },
        {
          citycode: "0833",
          adcode: "511129",
          name: "沐川县",
          center: {
            lng: 103.902691,
            lat: 28.956394
          }
        },
        {
          citycode: "0833",
          adcode: "511133",
          name: "马边彝族自治县",
          center: {
            lng: 103.546347,
            lat: 28.83552
          }
        },
        {
          citycode: "0833",
          adcode: "511102",
          name: "市中区",
          center: {
            lng: 103.761329,
            lat: 29.555374
          }
        },
        {
          citycode: "0833",
          adcode: "511181",
          name: "峨眉山市",
          center: {
            lng: 103.484557,
            lat: 29.601189
          }
        }
      ]
    },
    {
      citycode: "0813",
      adcode: "510300",
      name: "自贡市",
      center: {
        lng: 104.779307,
        lat: 29.33924
      },
      districtList: [
        {
          citycode: "0813",
          adcode: "510321",
          name: "荣县",
          center: {
            lng: 104.417438,
            lat: 29.445461
          }
        },
        {
          citycode: "0813",
          adcode: "510322",
          name: "富顺县",
          center: {
            lng: 104.975193,
            lat: 29.181779
          }
        },
        {
          citycode: "0813",
          adcode: "510304",
          name: "大安区",
          center: {
            lng: 104.773982,
            lat: 29.36371
          }
        },
        {
          citycode: "0813",
          adcode: "510311",
          name: "沿滩区",
          center: {
            lng: 104.873826,
            lat: 29.27208
          }
        },
        {
          citycode: "0813",
          adcode: "510302",
          name: "自流井区",
          center: {
            lng: 104.777182,
            lat: 29.337295
          }
        },
        {
          citycode: "0813",
          adcode: "510303",
          name: "贡井区",
          center: {
            lng: 104.715294,
            lat: 29.345481
          }
        }
      ]
    },
    {
      citycode: "0830",
      adcode: "510500",
      name: "泸州市",
      center: {
        lng: 105.441866,
        lat: 28.87098
      },
      districtList: [
        {
          citycode: "0830",
          adcode: "510521",
          name: "泸县",
          center: {
            lng: 105.381879,
            lat: 29.1516
          }
        },
        {
          citycode: "0830",
          adcode: "510504",
          name: "龙马潭区",
          center: {
            lng: 105.437751,
            lat: 28.913257
          }
        },
        {
          citycode: "0830",
          adcode: "510503",
          name: "纳溪区",
          center: {
            lng: 105.371324,
            lat: 28.772888
          }
        },
        {
          citycode: "0830",
          adcode: "510524",
          name: "叙永县",
          center: {
            lng: 105.444777,
            lat: 28.155631
          }
        },
        {
          citycode: "0830",
          adcode: "510525",
          name: "古蔺县",
          center: {
            lng: 105.812694,
            lat: 28.038763
          }
        },
        {
          citycode: "0830",
          adcode: "510502",
          name: "江阳区",
          center: {
            lng: 105.434982,
            lat: 28.87881
          }
        },
        {
          citycode: "0830",
          adcode: "510522",
          name: "合江县",
          center: {
            lng: 105.831011,
            lat: 28.811278
          }
        }
      ]
    },
    {
      citycode: "0831",
      adcode: "511500",
      name: "宜宾市",
      center: {
        lng: 104.642826,
        lat: 28.752354
      },
      districtList: [
        {
          citycode: "0831",
          adcode: "511524",
          name: "长宁县",
          center: {
            lng: 104.920643,
            lat: 28.582866
          }
        },
        {
          citycode: "0831",
          adcode: "511503",
          name: "南溪区",
          center: {
            lng: 104.969147,
            lat: 28.846366
          }
        },
        {
          citycode: "0831",
          adcode: "511526",
          name: "珙县",
          center: {
            lng: 104.708986,
            lat: 28.439514
          }
        },
        {
          citycode: "0831",
          adcode: "511527",
          name: "筠连县",
          center: {
            lng: 104.511159,
            lat: 28.167981
          }
        },
        {
          citycode: "0831",
          adcode: "511523",
          name: "江安县",
          center: {
            lng: 105.066982,
            lat: 28.723797
          }
        },
        {
          citycode: "0831",
          adcode: "511528",
          name: "兴文县",
          center: {
            lng: 105.236207,
            lat: 28.303669
          }
        },
        {
          citycode: "0831",
          adcode: "511502",
          name: "翠屏区",
          center: {
            lng: 104.619853,
            lat: 28.766537
          }
        },
        {
          citycode: "0831",
          adcode: "511529",
          name: "屏山县",
          center: {
            lng: 104.346138,
            lat: 28.82867
          }
        },
        {
          citycode: "0831",
          adcode: "511525",
          name: "高县",
          center: {
            lng: 104.517748,
            lat: 28.436166
          }
        },
        {
          citycode: "0831",
          adcode: "511504",
          name: "叙州区",
          center: {
            lng: 104.533244,
            lat: 28.690068
          }
        }
      ]
    },
    {
      citycode: "0834",
      adcode: "513400",
      name: "凉山彝族自治州",
      center: {
        lng: 102.267713,
        lat: 27.881396
      },
      districtList: [
        {
          citycode: "0834",
          adcode: "513435",
          name: "甘洛县",
          center: {
            lng: 102.771441,
            lat: 28.959131
          }
        },
        {
          citycode: "0834",
          adcode: "513436",
          name: "美姑县",
          center: {
            lng: 103.132359,
            lat: 28.328591
          }
        },
        {
          citycode: "0834",
          adcode: "513434",
          name: "越西县",
          center: {
            lng: 102.507467,
            lat: 28.639874
          }
        },
        {
          citycode: "0834",
          adcode: "513422",
          name: "木里藏族自治县",
          center: {
            lng: 101.280216,
            lat: 27.928736
          }
        },
        {
          citycode: "0834",
          adcode: "513437",
          name: "雷波县",
          center: {
            lng: 103.571705,
            lat: 28.263202
          }
        },
        {
          citycode: "0834",
          adcode: "513423",
          name: "盐源县",
          center: {
            lng: 101.509038,
            lat: 27.422593
          }
        },
        {
          citycode: "0834",
          adcode: "513433",
          name: "冕宁县",
          center: {
            lng: 102.176622,
            lat: 28.550145
          }
        },
        {
          citycode: "0834",
          adcode: "513430",
          name: "金阳县",
          center: {
            lng: 103.248786,
            lat: 27.696735
          }
        },
        {
          citycode: "0834",
          adcode: "513429",
          name: "布拖县",
          center: {
            lng: 102.809157,
            lat: 27.7121
          }
        },
        {
          citycode: "0834",
          adcode: "513428",
          name: "普格县",
          center: {
            lng: 102.540901,
            lat: 27.376413
          }
        },
        {
          citycode: "0834",
          adcode: "513402",
          name: "会理市",
          center: {
            lng: 102.244774,
            lat: 26.655047
          }
        },
        {
          citycode: "0834",
          adcode: "513424",
          name: "德昌县",
          center: {
            lng: 102.175661,
            lat: 27.402832
          }
        },
        {
          citycode: "0834",
          adcode: "513401",
          name: "西昌市",
          center: {
            lng: 102.264166,
            lat: 27.89441
          }
        },
        {
          citycode: "0834",
          adcode: "513431",
          name: "昭觉县",
          center: {
            lng: 102.839849,
            lat: 28.015301
          }
        },
        {
          citycode: "0834",
          adcode: "513426",
          name: "会东县",
          center: {
            lng: 102.577979,
            lat: 26.634744
          }
        },
        {
          citycode: "0834",
          adcode: "513432",
          name: "喜德县",
          center: {
            lng: 102.412451,
            lat: 28.306429
          }
        },
        {
          citycode: "0834",
          adcode: "513427",
          name: "宁南县",
          center: {
            lng: 102.751587,
            lat: 27.061431
          }
        }
      ]
    },
    {
      citycode: "0812",
      adcode: "510400",
      name: "攀枝花市",
      center: {
        lng: 101.71846,
        lat: 26.582417
      },
      districtList: [
        {
          citycode: "0812",
          adcode: "510421",
          name: "米易县",
          center: {
            lng: 102.111073,
            lat: 26.896372
          }
        },
        {
          citycode: "0812",
          adcode: "510422",
          name: "盐边县",
          center: {
            lng: 101.854027,
            lat: 26.682611
          }
        },
        {
          citycode: "0812",
          adcode: "510411",
          name: "仁和区",
          center: {
            lng: 101.738615,
            lat: 26.497796
          }
        },
        {
          citycode: "0812",
          adcode: "510402",
          name: "东区",
          center: {
            lng: 101.704129,
            lat: 26.546484
          }
        },
        {
          citycode: "0812",
          adcode: "510403",
          name: "西区",
          center: {
            lng: 101.630557,
            lat: 26.5977
          }
        }
      ]
    },
    {
      citycode: "0836",
      adcode: "513300",
      name: "甘孜藏族自治州",
      center: {
        lng: 101.96231,
        lat: 30.04952
      },
      districtList: [
        {
          citycode: "0836",
          adcode: "513332",
          name: "石渠县",
          center: {
            lng: 98.102938,
            lat: 32.978728
          }
        },
        {
          citycode: "0836",
          adcode: "513328",
          name: "甘孜县",
          center: {
            lng: 99.991683,
            lat: 31.622731
          }
        },
        {
          citycode: "0836",
          adcode: "513330",
          name: "德格县",
          center: {
            lng: 98.580914,
            lat: 31.806118
          }
        },
        {
          citycode: "0836",
          adcode: "513331",
          name: "白玉县",
          center: {
            lng: 98.824025,
            lat: 31.209669
          }
        },
        {
          citycode: "0836",
          adcode: "513327",
          name: "炉霍县",
          center: {
            lng: 100.676014,
            lat: 31.390657
          }
        },
        {
          citycode: "0836",
          adcode: "513329",
          name: "新龙县",
          center: {
            lng: 100.311569,
            lat: 30.93917
          }
        },
        {
          citycode: "0836",
          adcode: "513326",
          name: "道孚县",
          center: {
            lng: 101.125157,
            lat: 30.979486
          }
        },
        {
          citycode: "0836",
          adcode: "513301",
          name: "康定市",
          center: {
            lng: 101.95687,
            lat: 29.998544
          }
        },
        {
          citycode: "0836",
          adcode: "513334",
          name: "理塘县",
          center: {
            lng: 100.269145,
            lat: 29.994228
          }
        },
        {
          citycode: "0836",
          adcode: "513335",
          name: "巴塘县",
          center: {
            lng: 99.110555,
            lat: 30.00533
          }
        },
        {
          citycode: "0836",
          adcode: "513325",
          name: "雅江县",
          center: {
            lng: 101.014366,
            lat: 30.031498
          }
        },
        {
          citycode: "0836",
          adcode: "513336",
          name: "乡城县",
          center: {
            lng: 99.798116,
            lat: 28.931081
          }
        },
        {
          citycode: "0836",
          adcode: "513337",
          name: "稻城县",
          center: {
            lng: 100.297369,
            lat: 29.03791
          }
        },
        {
          citycode: "0836",
          adcode: "513324",
          name: "九龙县",
          center: {
            lng: 101.507294,
            lat: 29.000347
          }
        },
        {
          citycode: "0836",
          adcode: "513338",
          name: "得荣县",
          center: {
            lng: 99.286366,
            lat: 28.713085
          }
        },
        {
          citycode: "0836",
          adcode: "513323",
          name: "丹巴县",
          center: {
            lng: 101.89054,
            lat: 30.878618
          }
        },
        {
          citycode: "0836",
          adcode: "513333",
          name: "色达县",
          center: {
            lng: 100.333011,
            lat: 32.268541
          }
        },
        {
          citycode: "0836",
          adcode: "513322",
          name: "泸定县",
          center: {
            lng: 102.234814,
            lat: 29.914103
          }
        }
      ]
    },
    {
      citycode: "0837",
      adcode: "513200",
      name: "阿坝藏族羌族自治州",
      center: {
        lng: 102.224504,
        lat: 31.899427
      },
      districtList: [
        {
          citycode: "0837",
          adcode: "513231",
          name: "阿坝县",
          center: {
            lng: 101.706548,
            lat: 32.902387
          }
        },
        {
          citycode: "0837",
          adcode: "513225",
          name: "九寨沟县",
          center: {
            lng: 104.2426,
            lat: 33.252008
          }
        },
        {
          citycode: "0837",
          adcode: "513233",
          name: "红原县",
          center: {
            lng: 102.544395,
            lat: 32.790841
          }
        },
        {
          citycode: "0837",
          adcode: "513228",
          name: "黑水县",
          center: {
            lng: 102.987592,
            lat: 32.069268
          }
        },
        {
          citycode: "0837",
          adcode: "513201",
          name: "马尔康市",
          center: {
            lng: 102.206386,
            lat: 31.905799
          }
        },
        {
          citycode: "0837",
          adcode: "513226",
          name: "金川县",
          center: {
            lng: 102.063821,
            lat: 31.47625
          }
        },
        {
          citycode: "0837",
          adcode: "513222",
          name: "理县",
          center: {
            lng: 103.163284,
            lat: 31.435831
          }
        },
        {
          citycode: "0837",
          adcode: "513224",
          name: "松潘县",
          center: {
            lng: 103.60428,
            lat: 32.655685
          }
        },
        {
          citycode: "0837",
          adcode: "513227",
          name: "小金县",
          center: {
            lng: 102.362984,
            lat: 30.995823
          }
        },
        {
          citycode: "0837",
          adcode: "513230",
          name: "壤塘县",
          center: {
            lng: 100.978526,
            lat: 32.265796
          }
        },
        {
          citycode: "0837",
          adcode: "513221",
          name: "汶川县",
          center: {
            lng: 103.590185,
            lat: 31.476875
          }
        },
        {
          citycode: "0837",
          adcode: "513223",
          name: "茂县",
          center: {
            lng: 103.85332,
            lat: 31.681727
          }
        },
        {
          citycode: "0837",
          adcode: "513232",
          name: "若尔盖县",
          center: {
            lng: 102.96738,
            lat: 33.578503
          }
        }
      ]
    },
    {
      citycode: "0835",
      adcode: "511800",
      name: "雅安市",
      center: {
        lng: 103.041538,
        lat: 30.009998
      },
      districtList: [
        {
          citycode: "0835",
          adcode: "511827",
          name: "宝兴县",
          center: {
            lng: 102.814156,
            lat: 30.382154
          }
        },
        {
          citycode: "0835",
          adcode: "511822",
          name: "荥经县",
          center: {
            lng: 102.846537,
            lat: 29.793254
          }
        },
        {
          citycode: "0835",
          adcode: "511802",
          name: "雨城区",
          center: {
            lng: 103.032868,
            lat: 30.005718
          }
        },
        {
          citycode: "0835",
          adcode: "511824",
          name: "石棉县",
          center: {
            lng: 102.358364,
            lat: 29.230963
          }
        },
        {
          citycode: "0835",
          adcode: "511803",
          name: "名山区",
          center: {
            lng: 103.109238,
            lat: 30.069837
          }
        },
        {
          citycode: "0835",
          adcode: "511823",
          name: "汉源县",
          center: {
            lng: 102.650417,
            lat: 29.344275
          }
        },
        {
          citycode: "0835",
          adcode: "511825",
          name: "天全县",
          center: {
            lng: 102.771745,
            lat: 30.05728
          }
        },
        {
          citycode: "0835",
          adcode: "511826",
          name: "芦山县",
          center: {
            lng: 102.933618,
            lat: 30.145077
          }
        }
      ]
    }
  ]
};

export default city;



// WEBPACK FOOTER //
// ./src/util/province/sichuan.js